import { __assign } from "tslib";
import React from 'react';
import { Modal } from '@tencent/tea-component';
import classNames from 'classnames';
;
export function BuyModal(props) {
    var _a;
    return (React.createElement(Modal, __assign({}, props, { className: classNames('tea-for-buy__modal', (_a = props.className) !== null && _a !== void 0 ? _a : '') })));
}
BuyModal.Body = Modal.Body;
BuyModal.Footer = Modal.Footer;
BuyModal.Message = Modal.Message;
BuyModal.config = Modal.config;
BuyModal.confirm = Modal.confirm;
BuyModal.success = Modal.success;
BuyModal.alert = Modal.alert;
BuyModal.error = Modal.error;
BuyModal.show = Modal.show;
BuyModal.onOpen = Modal.onOpen;
BuyModal.onClose = Modal.onClose;
// Object.entries(Modal).forEach(([key, value]: [string, any]) => {
//   // @ts-ignore
//   BuyModal[key] = value;
// });
//# sourceMappingURL=BuyModal.js.map